<template>
  <div class="upload-works-page">
    <!-- 上传作品卡片 -->
    <div class="card">
      <h3 class="card-title">上传作品</h3>
      <div class="video-section">
        <div class="video-player">
          <button class="btn-upload-video">上传视频</button>
        </div>
        <div class="video-actions">
          <button class="btn-copy" @click="copyUrl">复制推流地址</button>
          <button class="btn-start" @click="startLive">我要开播</button>
        </div>
      </div>
    </div>

    <!-- 视频资料卡片 -->
    <div class="card">
      <h3 class="card-title">视频资料</h3>
      <div class="video-info-form">
        <div class="form-row">
          <div class="form-col form-col-large">
            <label>视频介绍</label>
            <input v-model="form.intro" type="text" placeholder="🎀宁宁的快乐捕捉计划🦄少女广播站" />
          </div>
          <div class="form-col form-col-small">
            <label>视频分类</label>
            <div class="custom-select" @click="showDropdown = !showDropdown">
              <span class="select-text">{{ form.category || '请选择' }}</span>
              <i class="el-icon-arrow-down"></i>
              <div v-if="showDropdown" class="dropdown-menu">
                <div
                  v-for="item in categoryList"
                  :key="item.value"
                  class="dropdown-item"
                  @click.stop="selectCategory(item.label)"
                >
                  {{ item.label }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 视频封面 -->
      <div class="cover-section">
        <h4 class="cover-title">
          视频封面
          <span class="cover-tip">请根据视频比例选择图片上传</span>
        </h4>
        <div class="cover-upload-area">
          <div class="cover-frame cover-portrait">
            <button class="btn-cover-upload" @click="uploadPortrait">上传图片</button>
          </div>
          <div class="cover-frame cover-landscape">
            <button class="btn-cover-upload" @click="uploadLandscape">上传图片</button>
          </div>
        </div>
      </div>

      <!-- 谁可以看 -->
      <div class="visibility-section">
        <span class="visibility-label">谁可以看</span>
        <label class="radio-item">
          <input v-model="form.visibility" type="radio" value="public" />
          <span class="radio-custom"></span>
          <span class="radio-text">所有人</span>
        </label>
        <label class="radio-item">
          <input v-model="form.visibility" type="radio" value="private" />
          <span class="radio-custom"></span>
          <span class="radio-text">私密</span>
        </label>
      </div>
    </div>

    <!-- 开始上传按钮 -->
    <div class="submit-section">
      <button class="btn-submit" @click="submit">开始上传</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UploadWorksPage',
  data() {
    return {
      showDropdown: false,
      form: {
        intro: '',
        category: '',
        visibility: 'public'
      },
      categoryList: [
        { label: '音乐', value: 'music' },
        { label: '舞蹈', value: 'dance' },
        { label: '乐器', value: 'instrument' },
        { label: '脱口秀', value: 'talkshow' },
        { label: '二次元', value: 'anime' },
        { label: '颜值', value: 'beauty' },
        { label: '才艺', value: 'talent' },
        { label: '生活方式', value: 'lifestyle' }
      ]
    }
  },
  methods: {
    selectCategory(label) {
      this.form.category = label
      this.showDropdown = false
    },
    copyUrl() {
      this.$message.success('推流地址已复制')
    },
    startLive() {
      this.$emit('startLive')
    },
    uploadPortrait() {
      this.$emit('uploadPortrait')
    },
    uploadLandscape() {
      this.$emit('uploadLandscape')
    },
    submit() {
      if (!this.form.intro.trim()) {
        this.$message.error('请输入视频介绍')
        return
      }
      if (!this.form.category) {
        this.$message.error('请选择视频分类')
        return
      }
      this.$message.success('开始上传')
    }
  }
}
</script>

<style scoped lang="scss">
.upload-works-page {
  min-height: 100vh;
  background: #f5f5f5;
  padding: 20px;
}

.card {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 16px;
}

.card-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 0 0 20px 0;
}

// 视频区域
.video-section {
  .video-player {
    width: 100%;
    aspect-ratio: 16 / 9;
    background: #000;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;

    .btn-upload-video {
      padding: 10px 32px;
      background: #4a4a4a;
      border: none;
      border-radius: 20px;
      color: #fff;
      font-size: 14px;
      cursor: pointer;

      &:hover {
        background: #555;
      }
    }
  }

  .video-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .btn-copy {
      padding: 8px 24px;
      background: #fff;
      border: 1px solid #e0e0e0;
      border-radius: 20px;
      color: #666;
      font-size: 13px;
      cursor: pointer;

      &:hover {
        background: #f8f8f8;
      }
    }

    .btn-start {
      padding: 10px 32px;
      background: #8B5CF6;
      border: none;
      border-radius: 24px;
      color: #fff;
      font-size: 14px;
      cursor: pointer;

      &:hover {
        opacity: 0.9;
      }
    }
  }
}

// 视频资料表单
.video-info-form {
  margin-bottom: 24px;

  .form-row {
    display: flex;
    gap: 16px;
  }

  .form-col {
    &.form-col-large {
      flex: 3;
    }

    &.form-col-small {
      flex: 1;
    }

    label {
      display: block;
      font-size: 13px;
      color: #333;
      margin-bottom: 8px;
    }

    input {
      width: 100%;
      padding: 12px 16px;
      border: 1px solid #e8e8e8;
      border-radius: 24px;
      font-size: 14px;
      color: #333;
      background: #fafafa;
      outline: none;
      box-sizing: border-box;

      &:focus {
        border-color: #8B5CF6;
      }
    }

    .custom-select {
      position: relative;
      width: 100%;
      padding: 12px 16px;
      border: 1px solid #e8e8e8;
      border-radius: 24px;
      font-size: 14px;
      color: #333;
      background: #fafafa;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;

      .select-text {
        color: #999;
      }

      .el-icon-arrow-down {
        color: #999;
        font-size: 12px;
      }

      .dropdown-menu {
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        margin-top: 4px;
        background: #fff;
        border: 1px solid #e8e8e8;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        z-index: 100;
        max-height: 200px;
        overflow-y: auto;

        .dropdown-item {
          padding: 10px 16px;
          font-size: 14px;
          color: #333;
          cursor: pointer;

          &:hover {
            background: #f5f5f5;
          }
        }
      }
    }
  }
}

// 封面区域
.cover-section {
  margin-bottom: 24px;

  .cover-title {
    font-size: 15px;
    font-weight: 600;
    color: #333;
    margin: 0 0 16px 0;

    .cover-tip {
      font-size: 12px;
      color: #999;
      font-weight: normal;
      margin-left: 8px;
    }
  }

  .cover-upload-area {
    display: flex;
    gap: 40px;
    justify-content: center;

    .cover-frame {
      border: 1px solid #e0e0e0;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #f5f5ff;

      &.cover-portrait {
        width: 180px;
        height: 280px;
      }

      &.cover-landscape {
        width: 320px;
        height: 180px;
      }

      .btn-cover-upload {
        padding: 8px 32px;
        background: #b0b0b0;
        border: none;
        border-radius: 16px;
        color: #fff;
        font-size: 13px;
        cursor: pointer;

        &:hover {
          background: #999;
        }
      }
    }
  }
}

// 谁可以看
.visibility-section {
  display: flex;
  align-items: center;
  gap: 32px;

  .visibility-label {
    font-size: 15px;
    font-weight: 600;
    color: #333;
  }

  .radio-item {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;

    input[type="radio"] {
      display: none;
    }

    .radio-custom {
      width: 16px;
      height: 16px;
      border: 2px solid #8B5CF6;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;

      &::after {
        content: '';
        width: 8px;
        height: 8px;
        background: #8B5CF6;
        border-radius: 2px;
        transform: scale(0);
        transition: transform 0.2s ease;
      }
    }

    input[type="radio"]:checked + .radio-custom::after {
      transform: scale(1);
    }

    .radio-text {
      font-size: 14px;
      color: #333;
    }
  }
}

// 提交按钮
.submit-section {
  display: flex;
  justify-content: center;
  padding: 8px 0;

  .btn-submit {
    padding: 12px 48px;
    background: #8B5CF6;
    border: none;
    border-radius: 24px;
    color: #fff;
    font-size: 15px;
    cursor: pointer;

    &:hover {
      opacity: 0.9;
    }
  }
}
</style>